import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
} from '@telialt/common-theme/src/purpurSelectors';

export const TagList = styled.ul`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const CapsuleShapedLink = styled.a`
    display: inline-block;

    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderWeak')};
    color: ${getPurpurColor('textDefault')};
    background-color: ${getPurpurColor('backgroundSecondary')};

    padding: 0.625rem ${getPurpurSpacing('200')};
    text-decoration: none;
    transition:
        background ${getPurpurMotion('duration300')} ${getPurpurMotion('easingEaseOut')},
        color ${getPurpurMotion('duration300')} ${getPurpurMotion('easingEaseOut')},
        border-color ${getPurpurMotion('duration300')} ${getPurpurMotion('easingEaseOut')};

    ${purpurFocus()};

    &:focus {
        border-color: ${getPurpurColor('borderStrong')};
        text-decoration: none;
    }

    &:hover {
        border-color: ${getPurpurColor('borderInteractivePrimaryHover')};
        border-width: ${getPurpurBorder('widthSm')};
        background-color: ${getPurpurColor('backgroundInteractiveTransparentHover')};
        color: ${getPurpurColor('textInteractivePrimaryHover')};
        padding: calc(0.625rem - ${getPurpurBorder('widthXs')})
            calc(${getPurpurSpacing('200')} - ${getPurpurBorder('widthXs')});
        text-decoration: none;
    }

    &:active {
        border-color: ${getPurpurColor('borderInteractivePrimaryActive')};
        background-color: ${getPurpurColor('backgroundInteractiveTransparentActive')};
        color: ${getPurpurColor('textInteractivePrimaryActive')};
        padding: calc(0.625rem - ${getPurpurBorder('widthXs')})
            calc(${getPurpurSpacing('200')} - ${getPurpurBorder('widthXs')});
        text-decoration: none;
    }
`;
